import { initializeTestimonials } from './testimonial';
import { initializeWordCarousel } from './word-carousel';
import { initializeWorkWith } from './work-with';

function intitalizeCarousels() {
  initializeTestimonials();
  initializeWordCarousel();
  initializeWorkWith();
}

export { intitalizeCarousels };
